import { formatUnitToFitDisplay } from './unit';

// formatInteger / formatMyriad 의 명사 suffix 상수 — 매직 스트링 제거(web·admin 공용 vocabulary).
export const SUFFIX = {
  WON: '원',
  COUNT: '개',
  DEVICE: '대',
  PERSON: '명',
  TIMES: '회',
  PERCENT: '%',
  CASE: '건',
  TEMPERATURE: '℃',
  DEGREE: '°', // 각도(방위각·경사각)

  HOUR: '시간',
  MINUTE: '분',
  DAY: '일',
} as const;

// 정수 + 명사 suffix(개·대·원 등) — UNIT_MAP 안 쓰는 순수 숫자 포맷. 천단위 콤마 + 정수(반올림).
// suffix 가 있으면 값과 suffix 사이에 공백('0 원'·'5 개', magnitude 단위 표기와 일관) — bare(빈 suffix)는 trailing 공백 없음.
export function formatInteger(value: number | null | undefined, suffix = ''): string {
  return formatUnitToFitDisplay(value, {
    suffix: { text: suffix, space: suffix !== '' },
    minDecimals: 0,
    maxDecimals: 0,
    minSignificantDigits: 0,
  });
}

// 소수 N자리 고정 + 명사 suffix — 비율(%)·소수 지표(toFixed 대응). 정수는 formatInteger.
// suffix 가 있으면 값과 suffix 사이에 공백('0.00 시간'·'0.00 %') — bare(빈 suffix)는 trailing 공백 없음.
export function formatDecimal(value: number | null | undefined, suffix = '', decimals = 2): string {
  return formatUnitToFitDisplay(value, {
    suffix: { text: suffix, space: suffix !== '' },
    minDecimals: decimals,
    maxDecimals: decimals,
    minSignificantDigits: 0,
  });
}

// 만/억 압축표기 + 명사 suffix("90만 원" 류) — koreanMyriad 그룹핑. 정밀 표시가 필요하면 formatInteger.
export function formatMyriad(value: number | null | undefined, suffix = ''): string {
  return formatUnitToFitDisplay(value, {
    unit: 'koreanMyriad',
    suffix: { text: suffix, space: true },
  });
}
